import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import {autoPlay} from 'react-swipeable-views-utils';
import NewsStep from './NewsStep/NewsStep';
import Bullets from './Bullets/Bullets';
import {selectNews} from '../../appSlice';
import './loginNews.less';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export default function LoginNews() {
    const [activeStep, setActiveStep] = useState(0);
    const news = useSelector(selectNews);

    function handleStepChange(step) {
        setActiveStep(step);
    }

    return (
        <div className="login-news">
            <div className="news-steps-container">
                <AutoPlaySwipeableViews
                    axis="x"
                    index={activeStep}
                    onChangeIndex={handleStepChange}
                    interval={8000}
                    enableMouseEvents
                    className="news-steps"
                >
                    {news.map((step) => (
                        <NewsStep {...step} key={step.title} />
                    ))}
                </AutoPlaySwipeableViews>
            </div>
            <Bullets
                steps={news.length}
                activeStep={activeStep}
                onChange={handleStepChange}
            />
        </div>
    );
}
